/**
 * Availability columns dictionary
 */
export enum AvailabilityColumns {
  SpaceDetails_AvailabilityType = 1,
  SpaceDetails_AvailabilityStatus = 2,
  SpaceDetails_LeaseType = 8,
  SpaceDetails_SpaceUsageType = 5,
  SpaceDetails_SpaceUsageSubtype = 6,
  SpaceDetails_AvailableSpace = 3,
  SpaceDetails_AvailableSpaceUOM = 4,
  SpaceDetails_DateListed = 29,
  SpaceDetails_Vacant = 7,
  SpaceDetails_DateAvailable = 30,
  SpaceDetails_OffMarketDate = 705,
  SpaceDetails_OffMarketReason = 28,
  SpaceDetails_MaxContiguousSpaceUOM = 21,
  SpaceDetails_MinDivisibleSpaceUOM = 3717,
  SpaceDetails_MaxContiguousSpace = 20,
  SpaceDetails_ParkingCost = 324,
  SpaceDetails_SubDivide = 25,
  SpaceDetails_SubleaseExpiration = 32,
  SpaceDetails_ParkingCostUOM = 325,
  SpaceDetails_MinDivisibleSpace = 3716,
  SpaceDetails_ListingDescription = 23,
  SpaceDetails_ListingNotes = 3750,
  SpaceDetails_ResearcherNotes = 24,
  SpaceDetails_AlternateAddress = 3324,
  SpaceDetails_Alternate_Longitude = 3380,
  SpaceDetails_Alternate_Latitude = 3379,
  SpaceDetails_Alternate_StreetName = 3319,
  SpaceDetails_Alternate_Direction = 3321,
  SpaceDetails_Alternate_MajorCorridor = 3318,
  SpaceDetails_Alternate_StreetNumber = 3378,
  SpaceConditionType = 3897,
  SpaceDetails_ExpectedOccupancyDate = 17379,
  AvailStatusChangeHistory_StatusChangeDate = 17121,
  AvailStatusChangeHistory_SpaceAvailabilityStatusDesc = 17122,
  AvailStatusChangeHistory_StatusEndDate = 17312,
  Terms_MinAskingRateYearlyUOM = 16360,
  Terms_MaxTerm = 3723,
  Terms_MinAskingRateYearly = 16359,
  Terms_MaxAskingRateYearlyUOM = 16362,
  Terms_AskingRateType = 3719,
  Terms_MaxAskingRateMonthlyUOM = 16358,
  Terms_AskingPriceSale = 206,
  Terms_TINotes = 213,
  Terms_MaxAskingRateMonthly = 16357,
  Terms_MaxAskingRateYearly = 16361,
  Terms_AskingPriceSaleUOM = 207,
  Terms_MinAskingRateMonthlyUOM = 16356,
  Terms_MinAskingRateMonthly = 16355,
  Terms_Possession = 210,
  Terms_TIAllowance = 211,
  Terms_TIAllowanceUOM = 212,
  Terms_ListingExpiration = 214,
  Terms_MinTerm = 3722,
  Terms_AskingRateYearly = 3895,
  IndustrialSpecifications_ClearHeight = 401,
  IndustrialSpecifications_MinClear = 402,
  IndustrialSpecifications_MaxClear = 403,
  IndustrialSpecifications_CeilingHeight = 404,
  IndustrialSpecifications_Amps = 405,
  IndustrialSpecifications_Volts = 406,
  IndustrialSpecifications_OfficeSpace = 407,
  IndustrialSpecifications_GLDoors = 408,
  IndustrialSpecifications_GLDoorCount = 409,
  IndustrialSpecifications_RailDoors = 413,
  IndustrialSpecifications_RailDoorCount = 414,
  IndustrialSpecifications_RailServed = 415,
  IndustrialSpecifications_YardSpace = 416,
  IndustrialSpecifications_FoodPermitted = 417,
  IndustrialSpecifications_VentAvail = 418,
  IndustrialSpecifications_BayCount = 419,
  IndustrialSpecifications_BayDepth = 420,
  IndustrialSpecifications_BayWidth = 421,
  IndustrialSpecifications_DHDoorCount = 412,
  IndustrialSpecifications_DHDoors = 411,
  Property_PropertyID = 12008,
  Property_Division = 316,
  Property_Neighborhood = 320,
  Property_District = 319,
  Property_Submarket = 318,
  Property_LocalMarketArea = 16995,
  Property_Market = 317,
  Property_State = 311,
  Property_PropertyName = 304,
  Property_City = 310,
  Property_Address = 307,
  Property_ParkingRatio = 327,
  Property_YearBuilt = 321,
  Property_Floors = 306,
  Property_Class = 302,
  Property_StatisticalProperty = 328,
  Property_Country = 315,
  Property_PostalCode = 312,
  Property_Size = 305,
  Property_County = 313,
  Companies_PostalCodeCompany = 511,
  Companies_Role = 516,
  Companies_LocationName = 519,
  Companies_CityCompany = 509,
  Companies_CompanyID = 12009,
  Companies_NameCompany = 501,
  Companies_AddressCompany = 508,
  Companies_StateCompany = 510,
  Companies_Lessor = 3737,
  Companies_ListingAgency = 3736,
  Companies_Sublessor = 17120,
  Company_Tenure_Property_Ownership_Type = 18025,
  FloorSuite_FloorNumber = 18,
  FloorSuite_Suite = 17,
  FloorSuite_FullFloor = 19,
  Contact_NameContact = 16894,
  Contact_PhoneContact = 604,
  Contact_EmailContact = 603,
  Contact_ListingAgents = 3843,
  Contact_ContactID = 12010,
  Contact_PrimaryFlag = 17192,
  Privacy_PrivateFlag = 3945,
  Tags_Tags = 16711,
  Admin_AvailabilityID = 701,
  Admin_EDPMatchVerifiedOn = 3711,
  Admin_VerifiedOn = 3728,
  Admin_VerifiedBy = 3729,
  Admin_SourceApplication = 3713,
  Admin_SourceAppAvailabilityID = 3709,
  Admin_UpdatedOn = 707,
  Admin_EDPMatchVerified = 3727,
  Admin_EDPMatchVerifiedBy = 3710,
  Admin_UpdatedBy = 706,
  Admin_IncludeinTotal = 709,
  Admin_Source = 708,
  Admin_CreatedBy = 16337,
  Admin_CreatedOn = 16338,
  Admin_SourceDetail = 16412,
  Admin_MethodDetail = 16238,
  Admin_Method = 16226,
  Admin_Confidentiality = 3948,
  AvailabilityAmenityType = 17084,
  TotalAvailableSpace = 17263,
  ListingSource = 17010,
  AssociatedLeaseCompId = 17159,
  Ref_Property_Space_QualityType_Desc = 17353,
  AvailableSpace_ConditionType_Desc = 17152,
  Asking_Rental_RateYearly = 3895,
  Local_Authority_ChargePerArea_Value = 84,
  Service_ChargePerArea_Value = 89,
  Cam_ChargesPerAreaValue = 94,
  ListingRep = 379,
  SubleaseRep = 378,
  RecordHide = 17026,
  PriorTenant = 149,
  TerraceAvailable = 18200,
  TerraceArea = 18201,
  TerraceAreaUOM = 18202,
  Companies_ListingReps_Parent_Company = 18528,
  Companies_ListingReps_Company_Tenure = 18543,
  Companies_ListingReps_Agreement_Start_Date = 18542,
  Companies_ListingReps_Agreement_Signed_Date = 18541,
  Companies_ListingReps_Agreement_Expiry_Date = 18540,
  Companies_ListingReps_MandateStatus = 18604,
  Companies_ListingReps_NAICS_Code = 18539,
  Companies_ListingReps_Country_Company = 18538,
  Companies_ListingReps_Postal_CodeCompany = 18537,
  Companies_ListingReps_State_Company = 18536,
  Companies_ListingReps_City_Company = 18535,
  Companies_ListingReps_Address_Company = 18534,
  Companies_ListingReps_Location_Name = 18532,
  Companies_ListingReps_Location_ID = 18531,
  Companies_ListingReps_Company_ID = 18529,
  Companies_ListingReps_Sublease_Rep = 18527,
  Companies_ListingReps_Listing_Agency = 18526,
  Companies_ListingReps_Listing_Rep = 18525,
  Companies_ListingReps_Role = 18524,
  Companies_ListingReps_Name_Company = 18522,
  Companies_ListingReps_Alternate_Company_Name = 18560,
  ContactsListingReps_Phone_Contact = 18556,
  ContactsListingReps_Name_Contact = 18554,
  ContactsListingReps_Listing_Agents = 18553,
  ContactsListingReps_Last_Name = 18552,
  ContactsListingReps_Familiar_Name = 18548,
  ContactsListingReps_First_Name = 18549,
  ContactsListingReps_Contact_ID = 18544,
  ContactsListingReps_Contact_Location = 18545,
  ContactsListingReps_Email_Contact = 18546,
  ContactsListingReps_Title_Contact = 18559,
  ContactsListingReps_Sublease_Agent = 18558,
  ContactsListingReps_Primary_Flag = 18557,
  Companies_Others_Agreement_Expiry_Date = 18576,
  Companies_Others_Agreement_Signed_Date = 18577,
  Companies_Others_Agreement_Start_Date = 18578,
  Companies_Others_Company_Tenure = 18579,
  Companies_Others_Prior_Tenant = 18580,
  Companies_Others_Prior_Tenant_NAICS_Code = 18581,
  Companies_Others_Lessor = 18582,
  Companies_Others_Lessor_NAICS_Code = 18583,
  Companies_Others_Sublessor = 18584,
  Companies_Others_Alternate_Company_Name = 18586,
  Companies_Others_Sublessor_NAICS_Code = 18585,
  Companies_Others_Name_Company = 18561,
  Companies_Others_Role = 18562,
  Companies_Others_Parent_Company = 18564,
  Companies_Others_Company_ID = 18565,
  Companies_Others_Location_ID = 18567,
  Companies_Others_Location_Name = 18568,
  Companies_Others_Address_Company = 18570,
  Companies_Others_City_Company = 18571,
  Companies_Others_State_Company = 18572,
  Companies_Others_Postal_CodeCompany = 18573,
  Companies_Others_Country_Company = 18574,
  Companies_Others_NAICS_Code = 18575,
  Contacts_Others_Title_Contact = 18602,
  Contacts_Others_Primary_Flag = 18600,
  Contacts_Others_Phone_Contact = 18599,
  Contacts_Others_Name_Contact = 18597,
  Contacts_Others_Listing_Agents = 18596,
  Contacts_Others_Last_Name = 18595,
  Contacts_Others_First_Name = 18593,
  Contacts_Others_Contact_ID = 18587,
  Contacts_Others_Contact_Location = 18588,
  Contacts_Others_Email_Contact = 18589,
  Contacts_Others_Familiar_Name = 18591,
  Contacts_Others_Sublease_Agent = 18601,
  Estimated_Rent = 18704,
  Flyer = 18742,
  FloorPlan = 18743,
  ImageCard = 3944,
  SourceLineageSubSourceName = 18760,
  Note_Created_By = 18753,
  Note_Created_At = 18754,
  Note_Updated_By = 18755,
  Note_Updated_At = 18756,
  Measurements_Type = 3888,
  Measurements_Value = 3890,
  Measurements_Value_UOM = 3891,
  Measurements_Rent = 3904,
  Measurements_Notes = 3889,
  Measurements_Rent_UOM = 3905,
  Measurements_Outdoor_Area = 334,
  Measurements_Yard_Area = 341,
  Measurements_Workshop_Area = 340,
  Measurements_Storage_Area = 339,
  Measurements_Site_Area = 338,
  Measurements_Showroom_Area = 337,
  Measurements_Shared_Meeting_Conference_Area = 336,
  Measurements_Retail_Area = 335,
  Measurements_Mezzanine_Area = 331,
  Measurements_Warehouse_Area = 375,
  Measurements_Average_Room_Area = 281,
  Measurements_Balcony_Area = 282,
  Measurements_Canopy_Area = 283,
  Measurements_Climate_Control_Area = 284,
  Measurements_Dangerous_Goods_Area = 285,
  Measurements_Factory_Area = 286,
  Measurements_Hardstand_Area = 287,
  Measurements_Hotel_Area = 288,
  Measurements_Land_Area = 289,
  Measurements_Loading_Dock_Area = 330,
  Measurements_Office_Area = 332,
  Measurements_Other_Area = 333,
}

/**
 * Brand columns dictionary
 */
export enum BrandColumns {
  BrandDetails_BrandOrigin = 16866,
  BrandDetails_BusinessCategory = 16867,
  BrandDetails_BrandName = 16865,
  Companies_Role = 16870,
  Companies_CompanyID = 16886,
  Contacts_NameContact = 16876,
  Contacts_EmailContact = 16879,
  Contacts_PhoneContact = 16880,
  Contacts_FranchiseeContacts = 16884,
  Contacts_OwnerContacts = 16904,
  Contacts_ContactID = 16885,
}

/**
 * Lease columns dictionary
 */
export enum LeaseColumns {
  LeaseCompDetails_LeaseType = 1600,
  LeaseCompDetails_AreaLeased = 1602,
  LeaseCompDetails_AreaLeasedUOM = 1603,
  LeaseCompDetails_AreaLeasedEstimatedF = 220,
  LeaseCompDetails_Class = 17003,
  LeaseCompDetails_Vacant = 1609,
  LeaseCompDetails_Sublease = 1601,
  LeaseCompDetails_DaysonMarket = 1608,
  LeaseCompDetails_TenantNAICSCode = 16931,
  LeaseCompDetails_SpaceUseNAICS = 1606,
  LeaseCompDetails_SeatCount = 1615,
  LeaseCompDetails_PriorLocation = 1610,
  LeaseCompDetails_PriorLocationSize = 1611,
  LeaseCompDetails_Noncontiguousfloor = 1613,
  LeaseCompDetails_ParkingSpaceCount = 1671,
  LeaseCompDetails_ReservedParkingSpaceCount = 1672,
  LeaseCompDetails_ReservedParkingSpaceCost = 1673,
  LeaseCompDetails_ReservedParkingSpaceCostUOM = 1674,
  LeaseCompDetails_Notes = 1616,
  LeaseCompDetails_TenantStatus = 17847,
  LeaseCompDetails_OwnerOccupied = 18081,
  LeaseCompDetails_RecordType = 423,
  LeaseCompDetails_AlternateAddress = 3322,
  LeaseCompDetails_AlternateAddress_StreetName = 3313,
  LeaseCompDetails_AlternateAddress_Street1 = 3369,
  LeaseCompDetails_AlternateAddress_Latitude = 3370,
  LeaseCompDetails_AlternateAddress_Longitude = 3371,
  LeaseCompDetails_AlternateAddress_MajorCorridor = 3312,
  LeaseCompDetails_AlternateAddress_Direction = 3315,
  LeaseCompDetails_CorridorType = 18209,
  SpaceDetails_SpaceConditionType = 17347,
  Terms_SignedDate = 1632,
  Terms_OccupancyDate = 1634,
  Terms_RateType = 1629,
  Terms_StartDate = 1633,
  Terms_StartDateEstimatedF = 222,
  Terms_LeaseTerm = 1636,
  Terms_LeaseTermUOM = 1637,
  Terms_LeaseTermNonStd = 17165,
  Terms_LeaseTermNonStdUOM = 17166,
  Terms_EndDate = 1635,
  Terms_EndDateEstimatedF = 223,
  Terms_AskingRentMonthly = 1617,
  Terms_BaseRentMonthly = 1621,
  Terms_BaseRentMonthlyEstimatedF = 234,
  Terms_AskingRentMonthlyUOM = 1618,
  Terms_BaseRentMonthlyUOM = 1622,
  Terms_EffectiveRentMonthly = 1625,
  Terms_EffectiveRentMonthlyUOM = 1626,
  Terms_AskingRentYearly = 1619,
  Terms_AskingRentYearlyUOM = 1620,
  Terms_BaseRentYearly = 1623,
  Terms_BaseRentYearlyUOM = 1624,
  Terms_EffectiveRentYearly = 1627,
  Terms_EffectiveRentYearlyUOM = 1628,
  Terms_TIAllowance = 1639,
  Terms_TIAllowanceUOM = 1640,
  Terms_TIsasis = 1641,
  Terms_TINotes = 1642,
  Terms_EscalationValue = 1645,
  Terms_EscalationValueUOM = 1646,
  Terms_EscalationPercent = 1647,
  Terms_EscalationComments = 1649,
  Terms_FreeRentMonths = 1638,
  Terms_OtherConcessions = 1643,
  Terms_OptionNotes = 1644,
  Terms_TotalConsideration = 1630,
  Terms_PercentRentBreakpoint = 1648,
  Terms_TotalConsiderationUOM = 1631,
  Terms_RentTrend = 16910,
  Terms_TotalRentYearly = 18734,
  Terms_TotalRentYearlyUOM = 18735,
  Terms_EarlyTerminationDate = 17025,
  EscalationDetails_Escalationvalueamountuomdesc = 3854,
  EscalationDetails_Period = 3856,
  EscalationDetails_Amount = 3853,
  EscalationDetails_Escalation = 3855,
  EscalationDetails_EscalationOrder = 3852,
  Expenses_TaxCost = 1656,
  Expenses_TaxCostUOM = 1657,
  Expenses_TaxAssesmentYear = 1658,
  Expenses_InsuranceCost = 1659,
  Expenses_InsuranceCostUOM = 1660,
  Expenses_CAMs = 1661,
  Expenses_CAMsUOM = 1662,
  Expenses_OPEX = 1663,
  Expenses_OPEXUOM = 1664,
  Expenses_ExpenseStop = 1667,
  Expenses_UtilitiesCost = 1669,
  Expenses_UtlitiesCostUOM = 1670,
  IndustrialSpecifications_DHDoorCount = 1682,
  IndustrialSpecifications_OfficeArea = 1675,
  IndustrialSpecifications_OfficeAreaUOM = 1676,
  IndustrialSpecifications_Amps = 1677,
  IndustrialSpecifications_Volts = 1678,
  IndustrialSpecifications_GLDoors = 1679,
  IndustrialSpecifications_GLDoorCount = 1680,
  IndustrialSpecifications_DHDoors = 1681,
  IndustrialSpecifications_RailServed = 1683,
  IndustrialSpecifications_ClearHeight = 1684,
  IndustrialSpecifications_ClearHeightUOM = 3894,
  Property_SpaceUsageSubtype = 1605,
  Property_SpaceUsageType = 1604,
  Property_Division = 11899,
  Property_Submarket = 1705,
  Property_LocalMarketArea = 16998,
  Property_Market = 1704,
  Property_Class = 1687,
  Property_Tenancy = 1688,
  Property_PropertyName = 1689,
  Property_PropertySize = 1690,
  Property_FloorCount = 1691,
  Property_Address = 1692,
  Property_City = 1697,
  Property_State = 1698,
  Property_PostalCode = 1699,
  Property_Country = 1702,
  Property_District = 1706,
  Property_Neighborhood = 1707,
  Property_YearBuilt = 1708,
  Property_ParkingRatio = 1713,
  Property_PrimeProperty = 1716,
  Property_County = 11897,
  Property_PropertyID = 11873,
  Property_StatisticalProperty = 1715,
  Property_Latitude = 17019,
  Property_Longitude = 17020,
  Companies_NameCompany = 1719,
  Companies_Role = 1718,
  Companies_Lessor = 3746,
  Companies_TenantAgency = 3749,
  Companies_Sublessor = 323,
  Companies_SublessorRep = 377,
  Companies_Tenant = 3748,
  Companies_AddressCompany = 1761,
  Companies_CityCompany = 1727,
  Companies_StateCompany = 1728,
  Companies_PostalCodeCompany = 1729,
  Companies_LocationName = 1760,
  Companies_ListingAgency = 3747,
  Companies_CompanyID = 11883,
  Company_Tenure_Property_Ownership_Type = 18023,
  Companies_NAICSCode = 1723,
  Contacts_NameContact = 1733,
  Contacts_EmailContact = 1736,
  Contacts_PhoneContact = 1737,
  Contacts_ListingAgents = 3840,
  Contacts_TenantAgents = 3839,
  Contacts_ContactID = 16432,
  Contacts_PrimaryFlag = 17818,
  FloorSuite_Floor = 1694,
  FloorSuite_Suite = 1695,
  FloorSuite_SpaceSize = 16905,
  FloorSuite_SpaceSizeUOM = 16906,
  FloorSuite_FullFloor = 3935,
  FloorSuite_Status = 428,
  FloorSuite_StartDate = 425,
  FloorSuite_EndDate = 426,
  FloorSuite_OccupancyDate = 427,
  FloorSuite_AlternateAddress = 3323,
  FloorSuite_AlternateAddress_Latitude = 3376,
  FloorSuite_AlternateAddress_Longitude = 3377,
  FloorSuite_AlternateAddress_CorridorType = 3372,
  FloorSuite_AlternateAddress_StreetName = 3373,
  FloorSuite_AlternateAddress_Direction = 3374,
  FloorSuite_AlternateAddress_StreetNumber = 3375,
  FloorSuite_SpaceActivityType = 18715,
  FloorSuite_SpaceLeasedArea = 18726,
  FloorSuite_TerraceArea = 7001,
  FloorSuite_SpaceBaseRentYearly = 18720,
  FloorSuite_Terrace = 7000,
  FloorSuite_TerraceAreaUOM = 7002,
  FloorSuite_FloorDescription = 7003,
  FloorSuite_Asking = 7004,
  FloorSuite_AskingUOM = 7005,
  FloorSuite_RentType = 7006,
  FloorSuite_SpaceLeasedAreaUOM = 18727,
  FloorSuite_SpaceBaseRentYearlyUOM = 18721,
  Privacy_PrivateExpirationDate = 17072,
  Privacy_PrivateFlag = 17071,
  Privacy_PrivateReason = 17073,
  Tags_Tags = 16709,
  Admin_EDPMatchVerified = 1750,
  Admin_VoucherID = 1744,
  Admin_EDPMatchVerifiedOn = 1752,
  Admin_CreatedOn = 1754,
  Admin_UpdatedOn = 1756,
  Admin_Confidentiality = 1742,
  Admin_SourceApplication = 3077,
  Admin_UpdatedBy = 1755,
  Admin_CreatedBy = 1753,
  Admin_SourceAppLeaseCompID = 3076,
  Admin_CompStatus = 1743,
  Admin_AccountType = 16399,
  Admin_Method = 16407,
  Admin_Source = 16406,
  Admin_VerifiedOn = 3730,
  Admin_MethodDetail = 16405,
  Admin_VerifiedBy = 3731,
  Admin_EDPMatchVerifiedBy = 1751,
  Admin_SourceDetail = 1748,
  Admin_CompID = 1741,
  Admin_HideLease = 17029,
  Admin_TIMID = 17083,
  Admin_AvailabilityID = 17351,
  Admin_QCStatus = 216,
  LeaseRentReviewProvisions = 3950,
  LeaseRentReviewAmountUom = 3954,
  LeaseRentReviewComment = 3955,
  Brand_BrandName = 16898,
  Brand_BrandCategory = 16899,
  PriorLocation_CurrentGlobalRegion = 258,
  PriorLocation_CurrentDivision = 259,
  PriorLocation_CurrentMarket = 260,
  PriorLocation_CurrentSubmarket = 261,
  PriorLocation_CurrentDistrict = 262,
  PriorLocation_CurrentNeighborhood = 263,
  TerraceAvailable = 18211,
  TerraceArea = 18213,
  TerraceAreaUOM = 18214,
  CompCompanies_ListingReps_Country_Company = 18469,
  CompCompanies_ListingReps_NAICS_Code = 18470,
  CompCompanies_ListingReps_Company_Tenure = 18471,
  CompCompanies_ListingReps_Alternate_Company_Name = 18472,
  CompCompanies_ListingReps_Role = 18456,
  CompCompanies_ListingReps_Listing_Agency = 18457,
  CompCompanies_ListingReps_Sublease_Rep = 18458,
  CompCompanies_ListingReps_Parent_Company = 18459,
  CompCompanies_ListingReps_Company_ID = 18460,
  CompCompanies_ListingReps_Location_ID = 18462,
  CompCompanies_ListingReps_Location_Name = 18463,
  CompCompanies_ListingReps_Address_Company = 18465,
  CompCompanies_ListingReps_City_Company = 18466,
  CompCompanies_ListingReps_State_Company = 18467,
  CompCompanies_ListingReps_Postal_Code_Company = 18468,
  CompContacts_Listing_Reps_Contact_ID = 18473,
  CompContacts_Listing_Reps_Familiar_Name = 18474,
  CompContacts_Listing_Reps_First_Name = 18475,
  CompContacts_Listing_Reps_Last_Name = 18477,
  CompContacts_Listing_Reps_Listing_Agents = 18486,
  CompContacts_Listing_Reps_Email_Contact = 18485,
  CompContacts_Listing_Reps_Title_Contact = 18483,
  CompContacts_Listing_Reps_Primary_Flag = 18482,
  CompContacts_Listing_Reps_Phone_Contact = 18481,
  CompContacts_Listing_Reps_Name_Contact = 18479,
  CompContacts_Listing_Reps_Sublease_Agents = 18487,
  CompCompanies_Others_Location_Name = 18499,
  CompCompanies_Others_Address_Company = 18500,
  CompCompanies_Others_City_Company = 18501,
  CompCompanies_Others_State_Company = 18502,
  CompCompanies_Others_Postal_Code_Company = 18503,
  CompCompanies_Others_Country_Company = 18504,
  CompCompanies_Others_NAICS_Code = 18505,
  CompCompanies_Others_Company_Tenure = 18506,
  CompCompanies_Others_Alternate_Company_Name = 18507,
  CompCompanies_Others_Name_Company = 18488,
  CompCompanies_Others_Role = 18489,
  CompCompanies_Others_Lessor = 18490,
  CompCompanies_Others_Sublessor = 18491,
  CompCompanies_Others_Tenant = 18492,
  CompCompanies_Others_Tenant_Agency = 18493,
  CompCompanies_Others_Parent_Company = 18494,
  CompCompanies_Others_Company_ID = 18495,
  CompCompanies_Others_Location_ID = 18497,
  CompContacts_Others_Email_Contact = 18519,
  CompContacts_Others_Name_Contact = 18514,
  CompContacts_Others_Tenant_Agents = 18521,
  CompContacts_Others_Primary_Flag = 18517,
  CompContacts_Others_Title_Contact = 18518,
  CompContacts_Others_Phone_Contact = 18515,
  CompContacts_Others_Last_Name = 18512,
  CompContacts_Others_Contact_ID = 18508,
  CompContacts_Others_Familiar_Name = 18509,
  CompContacts_Others_First_Name = 18511,
  ArrangementOptionsOptionDetailType = 18674,
  ArrangementOptionsOptionDetailComment = 18676,
  ArrangementOptionsOptionDetailStartDate = 18675,
  ReasonChangeInTenantSpaceType = 18320,
  ArrangementNewToMarketType = 18612,
  MovingFrom_StreetNumberComment = 18682,
  MovingFrom_StreetDirectionComment = 18683,
  MovingFrom_StreetAddressComment = 18684,
  MovingFrom_CityComment = 18685,
  MovingFrom_SubmarketComment = 18692,
  MovingFrom_MarketComment = 18691,
  MovingFrom_AreaComment = 18690,
  MovingFrom_FloorDescComment = 18689,
  MovingFrom_FloorNumberComment = 18688,
  MovingFrom_FloorModifierComment = 18687,
  MovingFrom_StateComment = 18686,
  MovingFrom_PropertyId = 3956,
  MovingFrom_Division = 18707,
  MovingFrom_District = 18708,
  MovingFrom_GlobalRegion = 18706,
  ImageCard = 3942,
  SourceLineageSubSourceName = 18759,
  Measurements_Type = 3883,
  Measurements_Value = 3884,
  Measurements_Value_UOM = 3885,
  Measurements_Rent = 3915,
  Measurements_Notes = 3886,
  Measurements_Rent_UOM = 3916,
  Measurements_Outdoor_Area = 346,
  Measurements_Canopy_Area = 292,
  Measurements_Warehouse_Area = 376,
  Measurements_Average_Room_Area = 290,
  Measurements_Balcony_Area = 291,
  Measurements_Climate_Control_Area = 293,
  Measurements_Dangerous_Goods_Area = 294,
  Measurements_Factory_Area = 295,
  Measurements_Hardstand_Area = 296,
  Measurements_Hotel_Area = 297,
  Measurements_Land_Area = 298,
  Measurements_Loading_Dock_Area = 342,
  Measurements_Mezzanine_Area = 343,
  Measurements_Office_Area = 344,
  Measurements_Other_Area = 345,
  Measurements_Retail_Area = 347,
  Measurements_Shared_Meeting_Conference_Area = 348,
  Measurements_Showroom_Area = 349,
  Measurements_Site_Area = 350,
  Measurements_Storage_Area = 351,
  Measurements_Workshop_Area = 352,
  Measurements_Yard_Area = 353,
}

/**
 * Portfoliosale columns dictionary
 */
export enum PortfoliosaleColumns {
  PortfolioSalesDetails_PortfolioName = 16934,
  PortfolioSalesDetails_SalePrice = 16936,
  PortfolioSalesDetails_SalePriceUOM = 16937,
  PortfolioSalesDetails_NumberofBuildings = 16938,
  PortfolioSalesDetails_PortfolioSignedDate = 16939,
  PortfolioSalesDetails_CloseDate = 16940,
  PortfolioSalesDetails_GrossArea = 16941,
  PortfolioSalesDetails_GrossAreaUOM = 16942,
  PortfolioSalesDetails_RemainingArea = 16943,
  PortfolioSalesDetails_RemainingAreaUOM = 16944,
  PortfolioSalesDetails_Notes = 17033,
  PortfolioSalesDetails_PriceperSqFt = 17034,
  PortfolioSalesDetails_PriceperSqFtAreaUOM = 17035,
  PortfolioSalesDetails_PriceperSqFtCurrencyUOM = 17050,
  PortfolioSaleProperties_Address = 16987,
  PortfolioSaleProperties_Market = 16988,
  PortfolioSaleProperties_SalePriceActual = 16982,
  PortfolioSaleProperties_SalePriceActualUOM = 16983,
  PortfolioSaleProperties_SignedDate = 16985,
  PortfolioSaleProperties_Size = 16986,
  PortfolioSaleProperties_SpaceUsageType = 17024,
  PortfolioSaleProperties_ApportionedPrice = 16980,
  PortfolioSaleProperties_ApportionedPriceUOM = 16981,
  PortfolioSaleProperties_CapRate = 16990,
  PortfolioSaleProperties_CompID = 16989,
  PortfolioSaleProperties_PropertyID = 16991,
  PortfolioSaleProperties_PropertyName = 17058,
  Companies_NameCompany = 16958,
  Companies_Role = 16959,
  Companies_ParentCompany = 16960,
  Companies_LocationCompany = 16961,
  Companies_AddressCompany = 16962,
  Companies_CityCompany = 16963,
  Companies_StateCompany = 16964,
  Companies_PostalCodeCompany = 16965,
  Companies_Seller = 16966,
  Companies_SellerAgency = 16967,
  Companies_Buyer = 16968,
  Companies_BuyerAgency = 16969,
  Companies_CompanyID = 16970,
  Companies_NAICSCode = 16971,
  Contacts_NameContact = 16972,
  Contacts_PhoneContact = 16975,
  Contacts_EmailContact = 16976,
  Contacts_ContactID = 16977,
  Contacts_BuyerAgents = 16978,
  Contacts_SellerAgents = 16979,
  Admin_PortfolioID = 17040,
  Admin_CreatedOn = 16949,
  Admin_CreatedBy = 16948,
  Admin_SourceApplication = 16946,
  Admin_UpdatedOn = 16951,
  Admin_UpdatedBy = 16950,
  Admin_SourceApplicationID = 16947,
  Admin_VerifiedOn = 16953,
  Admin_VerifiedBy = 16952,
  Admin_Verified = 16954,
  Admin_EDPMatchVerifiedOn = 16956,
  Admin_EDPMatchVerifiedBy = 16955,
  Admin_EDPMatchVerified = 16957,
  Admin_Confidentiality = 16945,
}

/**
 * Property columns dictionary
 */
export enum PropertyColumns {
  ImageCard = 3941,
  PropertyDetails_NRA = 846,
  PropertyDetails_TenancyType = 845,
  PropertyDetails_NRAUOM = 847,
  PropertyDetails_GrossArea = 848,
  PropertyDetails_GrossAreaUOM = 849,
  PropertyDetails_PropertyName = 850,
  PropertyDetails_Status = 839,
  PropertyDetails_PremierProperty = 1054,
  PropertyTypeDetails_Type = 842,
  PropertyTypeDetails_Statistical = 1050,
  PropertyTypeDetails_NRAPropertyType = 899,
  PropertyTypeDetails_NRAUOMPropertyType = 900,
  PropertyTypeDetails_GrossAreaPropertyType = 901,
  PropertyTypeDetails_Subtype = 843,
  PropertyTypeDetails_Institutional = 1051,
  PropertyTypeDetails_Class = 844,
  PropertyTypeDetails_PrimeProperty = 1052,
  PropertyTypeDetails_GrossAreaUOMPropertyType = 902,
  PropertyTypeDetails_TotalNumberofUnit = 3865,
  PropertyTypeDetails_Primary = 1070,
  PropertyTypeDetails_SignboardInformation = 17057,
  PropertyTypeDetails_CoStar_Auto_Add = 18750,
  PropertyTypeDetails_CoStar_Auto_Approve = 18751,
  LandConstructionParking_ParcelNumber = 3718,
  LandConstructionParking_TotalLandArea = 999,
  LandConstructionParking_TotalLandAreaUOM = 1000,
  LandConstructionParking_MonthBuilt = 867,
  LandConstructionParking_YearBuilt = 868,
  LandConstructionParking_MonthRenovated = 869,
  LandConstructionParking_YearRenovated = 870,
  LandConstructionParking_ConstructionType = 871,
  LandConstructionParking_ZoningCode = 3715,
  LandConstructionParking_BTSSpec = 16400,
  LandConstructionParking_LotNumber = 866,
  LandConstructionParking_ParkingSpaceCount = 883,
  LandConstructionParking_ParkingRatio = 884,
  LandConstructionParking_ParkingComment = 885,
  LandConstructionParking_MonthConstructionStarted = 16785,
  LandConstructionParking_YearConstructionStarted = 3860,
  Address_Address = 851,
  Address_City = 854,
  Address_State = 855,
  Address_PostalCode = 856,
  Address_County = 858,
  Address_Country = 857,
  Address_Longitude = 3847,
  Address_Latitude = 3846,
  Address_District = 16701,
  Address_StreetType = 17047,
  Address_DistrictColloquial = 16705,
  Address_PreStreetDirection = 17045,
  Address_PostStreetDirection = 17046,
  Address_Stree1 = 16704,
  Address_Street_Name = 13012,
  AlternateAddress_Address = 18045,
  AlternateAddress_District = 18047,
  AlternateAddress_PostCode = 18048,
  AlternateAddress_Latitude = 18049,
  AlternateAddress_Longitude = 18050,
  AlternateAddress_County = 18051,
  AlternateAddress_Country = 18052,
  AlternateAddress_StreetName = 18054,
  AlternateAddress_Street1 = 18053,
  AlternateAddress_Town = 18046,
  AlternateAddress_BuildingName = 2578,
  AlternateAddress_AddressUsageType = 18055,
  AlternateAddress_Direction = 3311,
  AlternateAddress_MajorCorridor = 3310,
  AlternateAddress_Usage = 18740,
  DebtFreeTypeDesc = 3306,
  ElevatorFloor_CommonFloorSizeUOM = 918,
  ElevatorFloor_MaximumFloorAreaUOM = 916,
  ElevatorFloor_Floors = 910,
  ElevatorFloor_CommonFloorSize = 917,
  ElevatorFloor_OwnerOccupied = 873,
  ElevatorFloor_LossFactor = 874,
  ElevatorFloor_ElevatorBanks = 887,
  ElevatorFloor_ElevatorCount = 888,
  ElevatorFloor_ElevatorCapacity = 889,
  ElevatorFloor_ElevatorCapacityUOM = 890,
  ElevatorFloor_FreightElevatorCount = 891,
  ElevatorFloor_FreightElevatorCapacity = 892,
  ElevatorFloor_FreightElevatorCapacityUOM = 893,
  ElevatorFloor_MaximumFloorArea = 915,
  ElevatorFloor_MinimumFloorAreaUOM = 914,
  ElevatorFloor_MinimumFloorArea = 913,
  OtherPropertyCharacteristics_TerraceArea = 894,
  OtherPropertyCharacteristics_TerraceAreaUOM = 895,
  OtherPropertyCharacteristics_OPEXBuilding = 924,
  OtherPropertyCharacteristics_OPEXUOMBuilding = 925,
  OtherPropertyCharacteristics_OPEXYearBuilding = 926,
  OtherPropertyCharacteristics_CAMsBuilding = 927,
  OtherPropertyCharacteristics_CAMsUOMBuilding = 928,
  OtherPropertyCharacteristics_CAMNotesBuilding = 929,
  OtherPropertyCharacteristics_SprinklerType = 949,
  OtherPropertyCharacteristics_Coverage = 1009,
  OtherPropertyCharacteristics_FAR = 1010,
  Comps_LastSalePrice = 1042,
  Comps_LastSaleDate = 1044,
  Comps_LastSalePriceUOM = 1043,
  Notes_PropertyNotes = 896,
  Notes_ResearchNotes = 897,
  Notes_DIGNotes = 898,
  ExternalRatings_ExternalRating = 1064,
  ExternalRatings_ExternalRatingCategory = 1065,
  ExternalRatings_ExternalRatingLevel = 1066,
  ExternalRatings_ExternalRatingDate = 1067,
  ExternalRatings_CertificationScore = 394,
  ExternalRatings_CertificationValidUntil = 395,
  ExternalRatings_CertificationStandard = 392,
  ExternalRatings_CertificationNumber = 393,
  ExternalRatings_ExternalRatingcomment = 17056,
  Property_measurement = 3876,
  Companies_NameCompany = 1012,
  Companies_Role = 1011,
  Company_Tenure_Property_Ownership_Type = 17246,
  Company_Party_Agreement_Type = 17313,
  Companies_ListingAgency = 3739,
  Companies_CompanyID = 13156,
  Companies_AddressCompany = 1019,
  Companies_PostalCodeCompany = 1022,
  Companies_StateCompany = 1021,
  Companies_Owner = 3738,
  Companies_LocationNameCompany = 1033,
  Companies_CityCompany = 1020,
  Companies_ParentCompany = 16918,
  Companies_Architect = 17098,
  Companies_AssetManager = 390,
  Companies_Developer = 3861,
  Companies_PropertyManager = 3863,
  Companies_TrueOwner = 391,
  Companies_LegalOwner = 3862,
  Contacts_NameContact = 1026,
  Contacts_PhoneContact = 1030,
  Contacts_EmailContact = 1029,
  Contacts_ListingAgents = 3838,
  Contacts_ContactID = 13155,
  Contacts_FirstName = 1027,
  Contacts_PrimaryFlag = 2510,
  Contact_FamiliarName = 18140,
  Location_Division = 860,
  Location_LocalMarketArea = 16996,
  Location_Market = 861,
  Location_Submarket = 862,
  Location_District = 863,
  Location_Neighborhood = 864,
  Location_RoadCorridor = 3882,
  AvailabilityVacancy_DirectVacantNotAvailableSpace = 16395,
  AvailabilityVacancy_DirectVacantNotAvailableSpaceUOM = 16396,
  AvailabilityVacancy_SubleaseVacantNotAvailableSpaceUOM = 16398,
  AvailabilityVacancy_SubleaseVacantNotAvailableSpace = 16397,
  AvailabilityVacancy_TotalVacantNotAvailableSpace = 16380,
  AvailabilityVacancy_TotalVacantNotAvailableSpaceUOM = 16381,
  AvailabilityVacancy_TotalVacantAvailableSpace = 17487,
  AvailabilityVacancy_TotalVacantAvailableSpaceUOM = 17488,
  AvailabilityVacancy_DirectVacantSpace = 1077,
  AvailabilityVacancy_DirectVacantSpaceUOM = 1078,
  AvailabilityVacancy_SubleaseVacantSpace = 1079,
  AvailabilityVacancy_SubleaseVacantSpaceUOM = 1080,
  AvailabilityVacancy_TotalVacantSpace = 1081,
  AvailabilityVacancy_TotalVacantSpaceUOM = 1082,
  AvailabilityVacancy_DirectAvailableSpace = 1071,
  AvailabilityVacancy_DirectAvailableSpaceUOM = 1072,
  AvailabilityVacancy_SubleaseAvailableSpace = 1073,
  AvailabilityVacancy_SubleaseAvailableSpaceUOM = 1074,
  AvailabilityVacancy_TotalAvailableSpace = 1075,
  AvailabilityVacancy_TotalAvailableSpaceUOM = 1076,
  AvailabilityVacancy_MaxContiguousSpaceAvailable = 16386,
  AvailabilityVacancy_MaxContiguousSpaceUOM = 16387,
  AvailabilityVacancy_MinDivisibleSpaceAvailable = 16384,
  AvailabilityVacancy_MinDivisibleSpaceUOM = 16385,
  AvailabilityVacancy_DateAvailable = 16388,
  AvailabilityVacancy_DirectVacantAvailableSpace = 17483,
  AvailabilityVacanct_DirectVacantAvailableSpaceUOM = 17484,
  AvailabilityVacancy_SubleaseVacantAvailableSpace = 17485,
  AvailabilityVacancy_SubleaseVacantAvailableSpaceUOM = 17486,
  RatesExpenses_RatesExpenses = 112,
  RatesExpenses_AverageDirectAskingRateYearly = 16374,
  RatesExpenses_AverageDirectAskingRateYearlyUOM = 16375,
  RatesExpenses_AverageSubleaseAskingRateYearly = 16378,
  RatesExpenses_AverageSubleaseAskingRateYearlyUOM = 16379,
  RatesExpenses_AverageSubleaseAskingRateMonthly = 16376,
  RatesExpenses_AverageSubleaseAskingRateMonthlyUOM = 16377,
  RatesExpenses_AverageDirectAskingRateMonthlyUOM = 16373,
  RatesExpenses_AverageDirectAskingRateMonthly = 16372,
  RatesExpenses_SubleaseAskingRateType = 16371,
  RatesExpenses_TaxCostPropertyType = 3858,
  RatesExpenses_MaxSubleaseAskingRateYearlyUOM = 16370,
  RatesExpenses_TaxCostUOMPropertyType = 3859,
  RatesExpenses_MinSubleaseAskingRateYearly = 16367,
  RatesExpenses_MinSubleaseAskingRateYearlyUOM = 16368,
  RatesExpenses_MaxSubleaseAskingRateYearly = 16369,
  RatesExpenses_MinSubleaseAskingRateMonthly = 16363,
  RatesExpenses_MinSubleaseAskingRateMonthlyUOM = 16364,
  RatesExpenses_MaxSubleaseAskingRateMonthly = 16365,
  RatesExpenses_MaxSubleaseAskingRateMonthlyUOM = 16366,
  RatesExpenses_MinDirectAskingRateYearly = 1087,
  RatesExpenses_MinDirectAskingRateYearlyUOM = 1088,
  RatesExpenses_MaxDirectAskingRateYearly = 1089,
  RatesExpenses_MaxDirectAskingRateYearlyUOM = 1090,
  RatesExpenses_MinDirectAskingRateMonthly = 1083,
  RatesExpenses_MinDirectAskingRateMonthlyUOM = 1084,
  RatesExpenses_MaxDirectAskingRateMonthly = 1085,
  RatesExpenses_MaxDirectAskingRateMonthlyUOM = 1086,
  RatesExpenses_DirectAskingRateType = 3720,
  RatesExpenses_TIAllowanceUOM = 12033,
  RatesExpenses_OPEXPropertyType = 930,
  RatesExpenses_OPEXUOMPropertyType = 931,
  RatesExpenses_OperatingExpenseYear = 424,
  RatesExpenses_InsuranceCostPropertyType = 932,
  RatesExpenses_InsuranceCostUOMPropertyType = 933,
  RatesExpenses_CAMsPropertyType = 934,
  RatesExpenses_CAMsUOMPropertyType = 935,
  RatesExpenses_OtherExpensesPropertyType = 936,
  RatesExpenses_OtherExpensesUOMPropertyType = 937,
  RatesExpenses_ExpenseStopAmount = 938,
  RatesExpenses_ExpenseStopAmountUOM = 939,
  RatesExpenses_UtilitiesCostPropertyType = 940,
  RatesExpenses_UtilitiesCostUOMPropertyType = 941,
  RatesExpenses_OpexMonthlyYearly = 17023,
  RatesExpenses_TIAllowance = 12032,
  OtherCharacteristics_ComputerArea = 903,
  OtherCharacteristics_ComputerAreaUOM = 904,
  OtherCharacteristics_HeatType = 905,
  OtherCharacteristics_HVACComments = 906,
  OtherCharacteristics_LightingComments = 907,
  OtherCharacteristics_RoofComments = 908,
  OtherCharacteristics_WaterType = 909,
  OtherCharacteristics_VacancyIndex = 1055,
  OtherCharacteristics_FullFloorAvailable = 1040,
  OtherCharacteristics_ParkingType = 886,
  IndustryClassification_NAICSCode = 1016,
  IndustrialCharacteristics_ColSpacing = 985,
  IndustrialCharacteristics_AirConditionedAreaUOM = 984,
  IndustrialCharacteristics_AirConditionedArea = 983,
  IndustrialCharacteristics_Tanks = 982,
  IndustrialCharacteristics_OfficeSpace = 980,
  IndustrialCharacteristics_CrossDockCount = 979,
  IndustrialCharacteristics_BayCount = 978,
  IndustrialCharacteristics_CraneCount = 977,
  IndustrialCharacteristics_InteriorPositions = 976,
  IndustrialCharacteristics_InteriorPositionsYN = 975,
  IndustrialCharacteristics_ExteriorPositions = 974,
  IndustrialCharacteristics_ExteriorPositionsYN = 973,
  IndustrialCharacteristics_RailDoors = 972,
  IndustrialCharacteristics_GLDoorCount = 970,
  IndustrialCharacteristics_GLDoors = 969,
  IndustrialCharacteristics_CraneTonnageUOM = 966,
  IndustrialCharacteristics_CraneTonnage = 965,
  IndustrialCharacteristics_CraneHeightUOM = 963,
  IndustrialCharacteristics_CleanRoomAreaUOM = 961,
  IndustrialCharacteristics_CleanRoomArea = 960,
  IndustrialCharacteristics_BayWidthUOM = 959,
  IndustrialCharacteristics_BayWidth = 958,
  IndustrialCharacteristics_BayDepthUOM = 957,
  IndustrialCharacteristics_BayDepth = 956,
  IndustrialCharacteristics_Amps = 955,
  IndustrialCharacteristics_Volts = 954,
  IndustrialCharacteristics_DHDoors = 971,
  IndustrialCharacteristics_DHDoorCount = 945,
  IndustrialCharacteristics_OfficeSpaceUOM = 981,
  IndustrialCharacteristics_ClearHeightMIN = 16930,
  IndustrialCharacteristics_ClearHeightMINUOM = 16929,
  IndustrialCharacteristics_ClearHeightMAX = 944,
  IndustrialCharacteristics_ClearHeightMAXUOM = 3767,
  IndustrialCharacteristics_FreezerAreaUOM = 951,
  IndustrialCharacteristics_RefrigeratedArea = 952,
  IndustrialCharacteristics_CraneNotes = 967,
  IndustrialCharacteristics_FreezerArea = 950,
  IndustrialCharacteristics_TruckwellCount = 948,
  IndustrialCharacteristics_CraneHeight = 962,
  IndustrialCharacteristics_RailDoorCount = 946,
  IndustrialCharacteristics_CraneServed = 964,
  IndustrialCharacteristics_CrossDocks = 968,
  IndustrialCharacteristics_Truckwells = 947,
  IndustrialCharacteristics_RefrigeratedAreaUOM = 953,
  IndustrialCharacteristics_GasType = 992,
  IndustrialCharacteristics_YardSpace = 989,
  IndustrialCharacteristics_RailNotes = 988,
  IndustrialCharacteristics_RailServed = 987,
  IndustrialCharacteristics_ColSpacingUOM = 986,
  RetailCharacteristics_AnchorTenantCount = 994,
  RetailCharacteristics_AnchorTenantNote = 995,
  RetailCharacteristics_FrontageLength = 996,
  RetailCharacteristics_IndustrialAmenities = 17053,
  LandCharacteristics_ExcessLand = 1008,
  LandCharacteristics_FrontageLengthUOM = 1005,
  LandCharacteristics_MajorStreetFrontage = 1003,
  LandCharacteristics_ParcelNumber = 997,
  LandCharacteristics_AvailableLandArea = 16382,
  LandCharacteristics_AvailableLandAreaUOM = 16383,
  LandCharacteristics_FloodPlain = 1007,
  LandCharacteristics_MSA = 998,
  LandCharacteristics_FloodMapNumber = 1006,
  DigitalInfo_Type = 3849,
  DigitalInfo_EmailAddressDigital = 3848,
  Tags_Tags = 16429,
  Admin_EDPMatchVerifiedBy = 3725,
  Admin_EDPMatchVerified = 3724,
  Admin_CreatedOn = 1057,
  Admin_PropertyID = 1048,
  Admin_UpdatedOn = 1060,
  Admin_VerifiedOn = 1061,
  Admin_CreatedBy = 1058,
  Admin_MethodDetail = 16404,
  Admin_Method = 16403,
  Admin_SourceDetail = 16402,
  Admin_Source = 16401,
  Admin_VerifiedBy = 1062,
  Admin_UpdatedBy = 1059,
  Admin_SourceAppPropertyID = 1094,
  Admin_SourceApplication = 1093,
  Admin_IronMountain = 1063,
  Admin_EDPMatchVerifiedOn = 3726,
  Admin_HideProperty = 16933,
  Admin_SPLastReviewDate = 18137,
  Admin_SPLastReviewBy = 18138,
  Admin_CoStarId = 18752,
  Property_Availabilities_External_Property_ID = 18789,
  Property_Availabilities_External_Property_ID_Source = 18790,
  PropertyAmenity_MetroLine = 16777,
  PropertyAmenity_AlternateMetroLine = 16802,
  PropertyAmenity_MetroStation = 16759,
  PropertyAmenity_AlternateMetroStation = 16801,
  PropertyAmenity_WalkingDistance = 16760,
  PropertyAmenity_AlternateWalkingDistance = 16803,
  PropertyAmenities_AmenityType = 34,
  PropertyAmenity_ExpiryDate = 17830,
  PropertyTypeAmenities_ExpiryDate = 17831,
  PropertyTypeAmenities_AmenityTypePropertyType = 37,
  PropertyTypeAmenities_AmenitySubTypePropertyType = 38,
  PropertyTypeAmenities_AmenityNotesPropertyType = 39,
  PropertyNotes_PropertyNotesType = 41,
  PropertyNotes_PropertyNotes = 40,
  PropertyExternalRef_PublicationId = 99,
  PropertyDevelopment_History_NotesId = 17113,
  PropertyDevelopment_Record_NotesId = 17095,
  PropertyDevelopment_Record_DevTypeId = 17088,
  PropertyDevelopment_Record_AvailabilityAmenityNotes = 17086,
  PropertyDevelopment_Record_StartDate = 17093,
  PropertyDevelopment_Record_DevCompletionDate = 17094,
  PropertyDevelopment_Record_CurrentDevelopmentStatus = 17319,
  PropertyDevelopment_CurrentDevelopmentStage = 17320,
  PropertyComplexName = 151,
  PropertyComplexFloorLoadingCapacity = 17355,
  PropertyComplexFloorLoadingCapacityUOM = 17356,
  PropertyComplexYearConstructionStarted = 17357,
  PropertyComplexYearBuilt = 17358,
  PropertyComplexNotes = 17363,
  CompanyAgreementSign = 18147,
  CompanyAgreementStart = 18145,
  CompanyAgreementStatus = 18156,
  CompanyAgreementEnd = 18146,
  Admin_SplitReviewStatus = 18153,
  Admin_SplitReviewUpdatedOn = 18155,
  Admin_SplitReviewUpdatedBy = 18154,
  PropertySets_PropertySet = 3305,
  Sale_PropertySet = 3307,
  Availability_PropertySet = 3308,
  Lease_PropertySet = 3309,
  Operating_Expense_Year = 18167,
  Companies_ListingReps_City_Company = 18333,
  Companies_ListingReps_Agreement_Signed_Date = 18323,
  Companies_ListingReps_Agreement_Status = 18324,
  Companies_ListingReps_Role = 18325,
  Companies_ListingReps_Name_Company = 18326,
  Companies_ListingReps_Company_ID = 18327,
  Companies_ListingReps_Country_Company = 18328,
  Companies_ListingReps_Listing_Agency = 18329,
  Companies_ListingReps_Postal_Code_Company = 18331,
  Companies_ListingReps_State_Company = 18332,
  Companies_ListingReps_Company_NAICS_Code = 18382,
  Companies_ListingReps_Address_Company = 18340,
  Companies_ListingReps_Funder = 18339,
  Companies_ListingReps_Alternate_Company_Name = 18338,
  Companies_ListingReps_Parent_Company = 18337,
  Companies_ListingReps_Company_Tenure = 18336,
  Companies_ListingReps_Agreement_Start_Date = 18321,
  Companies_ListingReps_Agreement_End_Date = 18322,
  Contacts_ListingReps_Listing_Agents = 18351,
  Contacts_ListingReps_Primary_Flag = 18350,
  Contacts_ListingReps_Last_Name = 18349,
  Contacts_ListingReps_Contact_ID = 18348,
  Contacts_ListingReps_Name_Contact = 18345,
  Contacts_ListingReps_Phone_Contact = 18344,
  Contacts_ListingReps_Email_Contact = 18343,
  Contacts_ListingReps_First_Name = 18342,
  Contacts_ListingReps_Familiar_Name = 18341,
  Companies_BuildingOwners_Address_Company = 18371,
  Companies_BuildingOwners_True_Owner = 18388,
  Companies_BuildingOwners_Company_NAICS_Code = 18387,
  Companies_BuildingOwners_Leasehold_Payment_UOM = 18386,
  Companies_BuildingOwners_Leasehold_Payment = 18385,
  Companies_BuildingOwners_Ownership_Perc = 18384,
  Companies_BuildingOwners_Ownership_Type = 18383,
  Companies_BuildingOwners_Agreement_Start_Date = 18352,
  Companies_BuildingOwners_Agreement_End_Date = 18353,
  Companies_BuildingOwners_Agreement_Signed_Date = 18354,
  Companies_BuildingOwners_Agreement_Status = 18355,
  Companies_BuildingOwners_Country_Company = 18359,
  Companies_BuildingOwners_Listing_Agency = 18360,
  Companies_BuildingOwners_Company_ID = 18361,
  Companies_BuildingOwners_Postal_Code_Company = 18362,
  Companies_BuildingOwners_State_Company = 18363,
  Companies_BuildingOwners_City_Company = 18364,
  Companies_BuildingOwners_Role = 18365,
  Companies_BuildingOwners_Name_Company = 18366,
  Companies_BuildingOwners_Company_Tenure = 18367,
  Companies_BuildingOwners_Parent_Company = 18368,
  Companies_BuildingOwners_Alternate_Company_Name = 18369,
  Companies_BuildingOwners_Funder = 18370,
  Contacts_BuildingOwners_Phone_Contact = 18374,
  Contacts_BuildingOwners_Email_Contact = 18373,
  Contacts_BuildingOwners_Listing_Agents = 18381,
  Contacts_BuildingOwners_Primary_Flag = 18380,
  Contacts_BuildingOwners_Contact_ID = 18378,
  Contacts_BuildingOwners_First_Name = 18377,
  Contacts_BuildingOwners_Last_Name = 18376,
  Contacts_BuildingOwners_Name_Contact = 18375,
  Companies_BuildingManagement_Country_Company = 18396,
  Companies_BuildingManagement_Listing_Agency = 18397,
  Companies_BuildingManagement_Postal_Code_Company = 18399,
  Companies_BuildingManagement_Agreement_Status = 18392,
  Companies_BuildingManagement_Agreement_Signed_Date = 18391,
  Companies_BuildingManagement_Agreement_End_Date = 18390,
  Companies_BuildingManagement_Agreement_Start_Date = 18389,
  Companies_BuildingManagement_Funder = 18407,
  Companies_BuildingManagement_Address_Company = 18408,
  Companies_BuildingManagement_Company_NAICS_Code = 18409,
  Companies_BuildingManagement_Property_Management_Agency = 18410,
  Companies_BuildingManagement_Asset_Manager = 18411,
  Companies_BuildingManagement_State_Company = 18400,
  Companies_BuildingManagement_City_Company = 18401,
  Companies_BuildingManagement_Role = 18402,
  Companies_BuildingManagement_Company_Tenure = 18404,
  Companies_BuildingManagement_Parent_Company = 18405,
  Companies_BuildingManagement_Alternate_Company_Name = 18406,
  Companies_BuildingManagement_Name_Company = 18394,
  Companies_BuildingManagement_Company_ID = 18395,
  Contacts_BuildingManagement_Listing_Agents = 18422,
  Contacts_BuildingManagement_Familiar_Name = 18412,
  Contacts_BuildingManagement_Email_Contact = 18414,
  Contacts_BuildingManagement_Phone_Contact = 18415,
  Contacts_BuildingManagement_Name_Contact = 18416,
  Contacts_BuildingManagement_Last_Name = 18417,
  Contacts_BuildingManagement_First_Name = 18418,
  Contacts_BuildingManagement_Contact_ID = 18419,
  Contacts_BuildingManagement_Primary_Flag = 18421,
  Companies_Others_Agreement_Signed_Date = 18433,
  Companies_Others_Address_Company = 18434,
  Companies_Others_City_Company = 18435,
  Companies_Others_State_Company = 18436,
  Companies_Others_Postal_Code_Company = 18437,
  Companies_Others_Country_Company = 18438,
  Companies_Others_Company_NAICS_Code = 18439,
  Companies_Others_Company_Tenure = 18440,
  Companies_Others_Funder = 18441,
  Companies_Others_Alternate_Company_Name = 18442,
  Companies_Others_Architect = 18443,
  Companies_Others_Developer = 18444,
  Companies_Others_Name_Company = 18423,
  Companies_Others_Role = 18425,
  Companies_Others_Parent_Company = 18427,
  Companies_Others_Company_ID = 18428,
  Companies_Others_Agreement_Start_Date = 18430,
  Companies_Others_Agreement_End_Date = 18431,
  Companies_Others_Agreement_Status = 18432,
  Contacts_Others_Email_Contact = 18447,
  Contacts_Others_Familiar_Name = 18445,
  Contacts_Others_First_Name = 18446,
  Contacts_Others_Contact_ID = 18452,
  Contacts_Others_Last_Name = 18450,
  Contacts_Others_Name_Contact = 18449,
  Contacts_Others_Phone_Contact = 18448,
  Contacts_Others_Primary_Flag = 18454,
  Contacts_Others_Listing_Agents = 18455,
  DirectAskingRateWeightedArea = 3327,
  DirectAskingRateWeightedAreaUOM = 3328,
  AverageSubleaseAskingRateWeightedArea = 3329,
  AverageSubleaseAskingRateWeightedAreaUOM = 3330,
  DirectAskingRateWeightedAreaReportedStats = 3337,
  DirectAskingRateWeightedAreaUOMReportedStats = 3338,
  SubleaseAskingRateWeightedAreaReportedStats = 3355,
  SubleaseAskingRateWeightedAreaUOMReportedStats = 3356,
  AverageOverallAskingRateYearly = 3331,
  AverageOverallAskingRateYearlyUOM = 3332,
  AverageOverallAskingRateYearlyReportedStats = 3335,
  AverageOverallAskingRateYearlyUOMReportedStats = 3336,
  TotalAvailableSpaceReportedStats = 3363,
  TotalAvailableSpaceUOMReportedStats = 3364,
  TotalVacantAvailableSpaceReportedStats = 3365,
  TotalVacantAvailableSpaceUOMReportedStats = 3366,
  TotalVacantNotAvailableSpaceReportedStats = 3367,
  TotalVacantNotAvailableSpaceUOMReportedStats = 3368,
  Tax_Year = 18301,
  Ownership_Type = 18308,
  Ownership_Percentage = 18309,
  Leasehold_Payment = 18310,
  TypicalColumn = 18190,
  SourceLineageSubSourceName = 18758,
}

/**
 * Tim columns dictionary
 */
export enum TimColumns {
  TIMCompany_NAICSCode = 16294,
  TIMCompany_TIMCompanyID = 16177,
  TIMCompany_TIMParentCompanyName = 16257,
  TIMCompany_TIMCompanyName = 16178,
  TIMCompany_TIMCompanyTradeName = 16179,
  TIMCompany_TIMCompanyLegalName = 16180,
  TIMCompany_TIMIndustryType = 18729,
  TIMDetails_TargetCity = 16140,
  TIMDetails_TIMType = 16162,
  TIMDetails_OnMarketDate = 16069,
  TIMDetails_TargetTransactionType = 16076,
  TIMDetails_TargetSpaceMax = 16108,
  TIMDetails_TargetSpaceMaxUOM = 16112,
  TIMDetails_TargetSpaceMin = 16106,
  TIMDetails_TargetSpaceMinUOM = 16107,
  TIMDetails_TIMComment = 16065,
  TIMDetails_TargetLocationNotes = 16064,
  TIMDetails_TargetSpaceUsageNAICS = 16062,
  TIMDetails_TIMStatus = 16071,
  TIMDetails_DealStatus = 16073,
  TIMDetails_CloseChangedDate = 16068,
  TIMDetails_TargetMoveinDate = 16070,
  TIMDetails_ReportingMarket = 3887,
  TIMDetails_RequirementOrigin = 18722,
  TIMDetails_TIMAliasCompanyID = 18777,
  TIMDetails_TIMAliasCompanyName = 18778,
  TIMDetails_ParentCompanyID = 18779,
  TIMDetails_ImmediateParentCompanyID = 18780,
  TIMDetails_ImmediateParentCompany = 18781,
  CurrentLocationDetails_CurrentSize = 16117,
  CurrentLocationDetails_CurrentClass = 16074,
  CurrentLocationDetails_RenewalProbability = 16118,
  CurrentLocationDetails_CurrentLocationNotes = 16063,
  CurrentLocationDetails_CurrentLeaseEndDate = 16067,
  TargetPropertyType_PropertyType = 16057,
  TargetPropertyType_PropertySubtype = 16066,
  TargetPropertyType_TargetClass = 16075,
  CurrentLocations_CurrentGlobalRegion = 16394,
  CurrentLocations_CurrentDivision = 16389,
  CurrentLocations_CurrentMarket = 16390,
  CurrentLocations_CurrentDistrict = 16392,
  CurrentLocations_CurrentSubmarket = 16391,
  CurrentLocations_CurrentNeighborhood = 16393,
  CurrentLocations_AddressComment = 18730,
  CurrentLocations_State = 18732,
  CurrentLocations_City = 18731,
  CurrentLocations_TargetLocalMarketArea = 17002,
  TargetLocations_TargetGlobalRegion = 16354,
  TargetLocations_TargetDivision = 16130,
  TargetLocations_TargetLocalMarketArea = 17001,
  TargetLocations_TargetMarket = 16131,
  TargetLocations_TargetSubmarket = 16137,
  TargetLocations_TargetDistrict = 16138,
  TargetLocations_TargetNeighborhood = 16139,
  Companies_LocationNameCompany = 16304,
  Companies_AddressCompany = 16268,
  Companies_CompanyID = 3762,
  Companies_CityCompany = 16270,
  Companies_StateCompany = 16272,
  Companies_LocationID = 16315,
  Companies_PostalCodeCompany = 16273,
  Companies_Role = 16269,
  Companies_NameCompany = 16274,
  Companies_TenantAgency = 3740,
  Contacts_NameContact = 16895,
  Contacts_EmailContact = 16299,
  Contacts_PhoneContact = 16306,
  Contacts_TenantAgents = 3845,
  Contacts_BrokerRepresentatives = 16714,
  Contacts_ContactID = 16316,
  Privacy_PrivateFlag = 17080,
  Privacy_PrivateExpirationDate = 17081,
  Privacy_PrivateReason = 17082,
  Tags_Tags = 16712,
  Admin_MethodDetail = 16061,
  Admin_SourceApplication = 16171,
  Admin_UpdatedOn = 16111,
  Admin_VerifiedOn = 3765,
  Admin_VerifiedBy = 3766,
  Admin_BusinessRelationship = 16056,
  Admin_CreatedBy = 16173,
  Admin_UpdatedBy = 16168,
  Admin_SourceApplicationTIMID = 16172,
  Admin_TIMID = 16163,
  Admin_CreatedOn = 16167,
  Admin_Method = 16072,
  Admin_SourceDetail = 16059,
  Admin_Source = 16060,
  Admin_ConfidentialityLevel = 16080,
  TimNotesTable_Date = 18737,
  TimNotesTable_Notes = 18739,
  TimNotesTable_NotesSource = 18736,
  TimNotesTable_AddedBy = 18738,
  TimNotesTable_RecentDate = 18748,
  TimNotesTable_RecentNotes = 18747,
  TimNotesTable_RecentSourceNotes = 18749,
  // Prior Property Table
  TimPriorAddress = 18858,
  TimPriorLeaseID = 18859,
  TimPriorLeaseEndDate = 18860,
  TimPriorPropertyClass = 18861,
  TimPriorSpaceSize = 18862,
  TimPriorSpaceSizeUOM = 18863,
  TimPriorPropertyID = 18864,
  TimPriorPropertyName = 18865,
  TimPriorMarket = 18866,
  TimPriorSubmarket = 18867,
  TimPriorDistrict = 18868,
  TimPriorPropertyType = 18869,
  TimPriorPropertySubtype = 18870,
  TimPropertyUsageID = 18871,
  TimPriorPropertyRenewalProbability = 18872,
}

/**
 * Company columns dictionary
 */
export enum CompanyColumns {
  CompanyDetails_LegalName = 1302,
  CompanyDetails_TradeStyleName = 1301,
  CompanyDetails_ParentCompanyName = 1304,
  CompanyDetails_ClientCareProgram = 1337,
  CompanyDetails_Name = 1300,
  CompanyDetails_SPOC = 1323,
  CompanyDetails_StockTicker = 1324,
  CompanyDetails_LegalDesignator = 1325,
  CompanyDetails_EmployeeCount = 1326,
  CompanyDetails_SinglePurposeEntity = 1328,
  CompanyDetails_AnnualRevenue = 1329,
  CompanyDetails_AnnualRevenueasof = 1330,
  CompanyDetails_CompanyLevel = 1331,
  CompanyDetails_InvestorProfile = 1332,
  CompanyDetails_Notes = 1338,
  CompanyDetails_AliasCompanyId = 18762,
  CompanyDetails_AliasCompanyName = 18763,
  CompanyDetails_ImmediateParentCompany = 18766,
  CompanyDetails_ParentCompanyID = 18764,
  CompanyDetails_ImmediateParentCompanyID = 18765,
  Locations_Address = 1309,
  Locations_Company = 1379,
  Locations_LocalMarketArea = 16997,
  Locations_Market = 1319,
  Locations_NameLocation = 1383,
  Locations_City = 1312,
  Locations_State = 1313,
  Locations_PostalCode = 1314,
  Locations_Country = 1315,
  Locations_Headquarters = 1327,
  Locations_Agency = 1378,
  Locations_Submarket = 1320,
  Locations_Tenant = 1380,
  Locations_Billing = 1381,
  Locations_Shipping = 1382,
  Locations_Division = 1318,
  Locations_Street1 = 11308,
  Locations_StreetName = 11309,
  Locations_Neighborhood = 1322,
  Locations_District = 1321,
  PhoneInfo_AreaCode = 1376,
  PhoneInfo_PhoneNumber = 1373,
  PhoneInfo_Ext = 1377,
  PhoneInfo_TypePhone = 1375,
  IndustryClassification_Primary = 3714,
  IndustryClassification_NAICSCode = 1307,
  IndustryType_Primary = 18725,
  IndustryType_Code = 18724,
  DigitalInfo_Type = 1374,
  DigitalInfo_EmailAddressDigital = 1372,
  LocationPhoneInfo_Ext = 1392,
  LocationPhoneInfo_PhoneNumber = 1389,
  LocationPhoneInfo_AreaCode = 1391,
  LocationPhoneInfo_TypePhone = 1390,
  Tags_Tags = 16430,
  Admin_SourceApplication = 1385,
  Admin_Status = 1359,
  Admin_SourceAppCompanyID = 1386,
  Admin_CreatedOn = 1368,
  Admin_UpdatedBy = 1369,
  Admin_UpdatedOn = 1370,
  Admin_VerifiedBy = 1387,
  Admin_VerifiedOn = 1388,
  Admin_DIGVerified = 1362,
  Admin_DIGVerificationNotes = 1363,
  Admin_EDPMatchVerified = 1364,
  Admin_EDPMatchVerifiedBy = 1365,
  Admin_EDPMatchVerifiedOn = 1366,
  Admin_CreatedBy = 1367,
  Admin_CompanyID = 1358,
  AgreementSign = 3932,
  AgreementStart = 3934,
  AgreementEnd = 3933,
  Interest = 17060,
  PortfolioInterest = 2595,
  Company_Hierarchy = 18712,
  Company_Isolation = 18746,
  SourceLineageSubSourceName = 18761,
  CombinedCompanySearchFilter = 18788,
}

/**
 * Contact columns dictionary
 */
export enum ContactColumns {
  ContactDetails_Name = 1401,
  ContactDetails_Salutation = 1402,
  ContactDetails_FirstName = 1403,
  ContactDetails_MiddleName = 1404,
  ContactDetails_LastName = 1405,
  ContactDetails_MaidenName = 1406,
  ContactDetails_Suffix = 1407,
  ContactDetails_LegalName = 1408,
  ContactDetails_FamiliarName = 1409,
  ContactDetails_Title = 1410,
  Privacy_GDPRConsentDate = 1448,
  Privacy_CallOption = 1447,
  Privacy_MailOption = 1446,
  Privacy_BadEmail = 1445,
  Privacy_DoNotCall = 1444,
  Companies_NameCompany = 1450,
  Companies_Role = 1400,
  Companies_LocationName = 1471,
  Companies_StartDate = 2304,
  Companies_CompanyID = 11520,
  Companies_State = 1517,
  Companies_City = 1516,
  Companies_Address = 1412,
  Companies_EndDate = 2305,
  Companies_Country = 1521,
  Companies_PostalCode = 1518,
  PhoneInfo_Ext = 1515,
  PhoneInfo_TypePhone = 1513,
  PhoneInfo_AreaCode = 1514,
  PhoneInfo_PhoneNumber = 1511,
  DigitalInfo_Type = 1512,
  DigitalInfo_EmailAddressDigital = 1411,
  Tags_Tags = 16431,
  Admin_CreatedBy = 1502,
  Admin_CBREEmployee = 1434,
  Admin_ContactID = 1500,
  Admin_SourceApplication = 1519,
  Admin_SourceAppContactID = 1520,
  Admin_CreatedOn = 1503,
  Admin_UpdatedBy = 1504,
  Admin_UpdatedOn = 1505,
  Admin_EDPMatchVerified = 1508,
  Admin_EDPMatchVerifiedBy = 1509,
  Admin_EDPMatchVerifiedOn = 1510,
  Admin_VerifiedOn = 3734,
  Admin_VerifiedBy = 3735,
}

/**
 * Sale columns dictionary
 */
export enum SaleColumns {
  ImageCard = 3943,
  SaleCompDetails_PreviousSaleDate = 2307,
  SaleCompDetails_BuyerObjective = 2308,
  SaleCompDetails_LeasebackType = 2309,
  SaleCompDetails_SignedDate = 2067,
  SaleCompDetails_SaleType = 2004,
  SaleCompDetails_NRA = 2007,
  SaleCompDetails_NRAUOM = 2008,
  SaleCompDetails_BuyerNAICSCode = 16932,
  SaleCompDetails_GrossArea = 2009,
  SaleCompDetails_GrossAreaUOM = 2010,
  SaleCompDetails_Propertycount = 2011,
  SaleCompDetails_LandArea = 2012,
  SaleCompDetails_LandAreaUOM = 2013,
  SaleCompDetails_SalePriceAsking = 2027,
  SaleCompDetails_SalePriceUom = 2028,
  SaleCompDetails_SalePriceActual = 2029,
  SaleCompDetails_SalePriceActualUOM = 2030,
  SaleCompDetails_SalePriceReported = 2031,
  SaleCompDetails_SalePriceReportedUOM = 2032,
  SaleCompDetails_PriceperAcre = 2039,
  SaleCompDetails_PriceperAcreUOM = 2040,
  SaleCompDetails_PriceperSqFt = 2043,
  SaleCompDetails_PricePerSquareFootUom = 2044,
  SaleCompDetails_NOI = 2060,
  SaleCompDetails_NOIUOM = 2061,
  SaleCompDetails_CapRateActual = 2062,
  SaleCompDetails_CapRateProforma = 2063,
  SaleCompDetails_CapRateList = 2064,
  SaleCompDetails_IRR = 2066,
  SaleCompDetails_RecordingDate = 2068,
  SaleCompDetails_CloseDate = 2069,
  SaleCompDetails_OwnershipType = 2079,
  SaleCompDetails_OwnershipInterestPurchased = 2080,
  SaleCompDetails_Occupancy = 2089,
  SaleCompDetails_Vacant = 2090,
  SaleCompDetails_DateonMarket = 2093,
  SaleCompDetails_DaysonMarket = 2094,
  SaleCompDetails_PortfolioName = 16994,
  SaleCompDetails_PortfolioSignedDate = 17032,
  SaleCompDetails_PortfolioSalePrice = 17041,
  SaleCompDetails_Notes = 2097,
  SaleCompDetails_LongNotes = 2098,
  SaleCompDetails_CapRateSale = 2306,
  SaleCompDetails_Status = 3924,
  SaleCompDetails_APNNumber = 18679,
  Contacts_NameContact = 2256,
  Contacts_EmailContact = 2263,
  Contacts_PhoneContact = 2264,
  Contacts_BuyerAgents = 3841,
  Contacts_SellerAgents = 3842,
  Contacts_ContactID = 14301,
  Contacts_PrimaryFlag = 2511,
  Property_Class = 2128,
  Property_Tenancy = 2130,
  Property_Campus = 2131,
  Property_PropertyName = 2132,
  Property_FloorCount = 2136,
  Property_Address = 2138,
  Property_City = 2146,
  Property_State = 2147,
  Property_PostalCode = 2148,
  Property_Country = 2152,
  Property_LocalMarketArea = 16999,
  Property_Market = 2154,
  Property_Submarket = 2155,
  Property_District = 2156,
  Property_Neighborhood = 2157,
  Property_YearBuilt = 2159,
  Property_ParkingRatio = 2164,
  Property_ConstructionType = 2310,
  Property_PropertySize = 2133,
  Property_SpaceUsageSubtype = 2021,
  Property_PropertyID = 14004,
  Property_Division = 2153,
  Property_ParkingCount = 14303,
  Property_SpaceUsageType = 2020,
  Property_StatisticalProperty = 2167,
  Property_Latitude = 17021,
  Property_Longitude = 17022,
  Property_County = 14117,
  IndustrialSpecifications_GLDoorCount = 2115,
  IndustrialSpecifications_WarehouseArea = 2101,
  IndustrialSpecifications_OfficeSpace = 2103,
  IndustrialSpecifications_OfficeSpaceUOM = 2104,
  IndustrialSpecifications_Amps = 2108,
  IndustrialSpecifications_Volts = 2109,
  IndustrialSpecifications_ElectricalPhase = 2110,
  IndustrialSpecifications_SprinklerType = 2116,
  IndustrialSpecifications_RailServed = 2111,
  IndustrialSpecifications_MinClear = 2112,
  IndustrialSpecifications_DHDoors = 2113,
  IndustrialSpecifications_WarehouseAreaUom = 2102,
  RetailSpecifications_RetailArea = 2119,
  RetailSpecifications_RetailAreaUOM = 2120,
  RetailSpecifications_LocationTypeDesc = 14127,
  Companies_TrueSeller = 382,
  Companies_LegalSeller = 383,
  Companies_TrueBuyer = 384,
  Companies_LegalBuyer = 385,
  Companies_NameCompany = 2217,
  Companies_NAICSCode = 2234,
  Companies_LocationCompany = 2267,
  Companies_Role = 2216,
  Companies_Buyer = 3744,
  Companies_BuyerAgency = 3745,
  Companies_Seller = 3742,
  Companies_SellerAgency = 3743,
  Companies_StateCompany = 2241,
  Companies_CityCompany = 2240,
  Companies_AddressCompany = 2239,
  Companies_PostalCodeCompany = 2242,
  Company_Tenure_Property_Ownership_Type = 18024,
  Companies_CompanyID = 3760,
  Privacy_PrivateFlag = 17074,
  Privacy_PrivateExpirationDate = 17075,
  Privacy_PrivateReason = 17076,
  Tags_Tags = 16710,
  Admin_VerifiedBy = 3733,
  Admin_VerifiedOn = 3732,
  Admin_CreatedOn = 2293,
  Admin_UpdatedBy = 2294,
  Admin_CompID = 2268,
  Admin_VoucherID = 2282,
  Admin_Confidentiality = 2271,
  Admin_EDPMatchVerifiedOn = 2300,
  Admin_EDPMatchVerified = 2298,
  Admin_UpdatedOn = 2295,
  Admin_Source = 16408,
  Admin_SourceAppCompID = 2330,
  Admin_SourceApplication = 2279,
  Admin_SourceDetail = 16409,
  Admin_EDPMatchVerifiedBy = 2299,
  Admin_CreatedBy = 2292,
  Admin_MethodDetail = 16410,
  Admin_Method = 16411,
  Admin_CompStatus = 2273,
  Admin_PortfolioID = 16992,
  Admin_PortfolioFlag = 16993,
  SaleRentReviewOccurrenceUOM = 17336,
  SaleRentReviewProvisionsArrangementOptions = 17338,
  RentReviewTypeDescProvisions = 17339,
  RentReviewPercentage = 17340,
  Brand_BrandName = 17852,
  Brand_BrandId = 17858,
  Brand_BusinessCategoryDesc = 17853,
}

/**
 * Tenancy columns dictionary
 */
export enum TenancyColumns {
  TenancyDetails_TenancyNotes = 3844,
  TenancyDetails_CompanyLegalName = 3773,
  TenancyDetails_CompanyTradestyleName = 3774,
  TenancyDetails_CompanyName = 3772,
  TenancyDetails_CompanyID = 3771,
  TenancyDetails_EmployeeCount = 3770,
  TenancyDetails_SizeUOM = 3769,
  TenancyDetails_SpaceUsageNAICS = 3775,
  TenancyDetails_TotalSize = 3768,
  FloorSuite_Status = 3785,
  FloorSuite_PropertyType = 3790,
  FloorSuite_Floor = 3778,
  FloorSuite_Suite = 3779,
  FloorSuite_CompID = 3787,
  FloorSuite_StartDate = 3782,
  FloorSuite_EndDate = 3784,
  FloorSuite_OccupancyDate = 17061,
  FloorSuite_SpaceSize = 3780,
  FloorSuite_Sublease = 3786,
  FloorSuite_SpaceSizeUOM = 3781,
  FloorSuite_FullFloor = 17096,
  FloorSuite_BaseRent = 16667,
  Property_GlobalRegion = 3794,
  Property_Submarket = 3801,
  Property_PropertyName = 3788,
  Property_LocalMarketArea = 17000,
  Property_Market = 3799,
  Property_Division = 3796,
  Property_Country = 3819,
  Property_County = 3818,
  Property_PostalCodeExtension = 3817,
  Property_PostalCode = 3816,
  Property_State = 3815,
  Property_City = 3814,
  Property_Address = 3807,
  Property_Neighborhood = 3805,
  Property_District = 3803,
  Property_PropertyID = 3789,
  Tags_Tags = 16713,
  Admin_Method = 16427,
  Admin_SourceDetail = 16426,
  Admin_UpdatedOn = 3834,
  Admin_UpdatedBy = 3833,
  Admin_VerifiedBy = 3836,
  Admin_CreatedOn = 3832,
  Admin_CreatedBy = 3831,
  Admin_Source = 3830,
  Admin_VerifiedOn = 3837,
  Admin_SourceApplicationID = 3829,
  Admin_SourceApplication = 3828,
  Admin_Confidentiality = 3827,
  Admin_TenancyID = 3826,
  Admin_MethodDetail = 16428,
  Admin_HideTenancy = 17028,
  Brand_BrandName = 16901,
  Brand_BrandCategory = 16902,
}
